import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";

export const LIST_ENVIRONMENTS = gql`
  query listEnvironments(
    $activityId: ID
    $createdBy: String
    $environmentId: ID
    $limit: Int!
    $cursor: String
  ) {
    listEnvironments(
      input: {
        activityId: $activityId
        createdBy: $createdBy
        environmentId: $environmentId
        limit: $limit
        cursor: $cursor
      }
    ) {
      environments {
        __typename
        environmentId
        environmentName
        state
        instanceStatus
        systemStatus
        createdBy
        actionId
        createdAt
        activityId
        image {
          imageId
          imageName
          platformDetails
          architecture
          createdAt
          software {
            name
            version
          }
        }
        instanceType {
          instanceTypeId
          cpu
          memory
          architectures
        }
        schedule
      }
      nextCursor
    }
  }
`;

export function useQueryEnvironmentsQuery(
  activityId?: number,
  polling: boolean = true,
  environmentId?: string,
  limit: number = 50,
  cursor?: string | null,
  createdBy?: string
) {
  const {
    data: environments,
    loading: isLoadingEnvironments,
    error: errorListEnvironments,
    refetch: refetchEnvironments,
    fetchMore: fetchMoreEnvironments
  } = useQuery(LIST_ENVIRONMENTS, {
    variables: {
      ...(activityId && { activityId }),
      ...(createdBy && { createdBy }),
      ...(environmentId && { environmentId }),
      ...(limit && { limit }),
      ...(cursor && { cursor })
    },
    context: { clientName: "interactive" },
    notifyOnNetworkStatusChange: true,
    ...(polling && { pollInterval: 100000 }) // Query data periodically every 100 sec to update status of the environments
  });

  const listMoreEnvironments = (limit: number, nextCursor: string) =>
    fetchMoreEnvironments({
      variables: {
        limit: limit,
        cursor: nextCursor
      },
      updateQuery: (prevResult, { fetchMoreResult }) => {
        fetchMoreResult.listEnvironments.environments = [
          ...(prevResult?.listEnvironments?.environments
            ? prevResult.listEnvironments.environments
            : []),
          ...fetchMoreResult.listEnvironments.environments
        ];
        return fetchMoreResult;
      }
    });

  useEffect(() => {
    if (environments && environments.listEnvironments.nextCursor) {
      listMoreEnvironments(limit, environments.listEnvironments.nextCursor);
    }
  }, [environments]);

  return {
    environments: environments?.listEnvironments?.environments || [],
    isLoadingEnvironments,
    errorListEnvironments,
    refetchEnvironments
  };
}
